import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import GroupResultModal from './modals/GroupResultModal';
import './PublisherLetterResults.css';

export default function PublisherLetterResults({ locale }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    axios.get('/publisher/finalized-groups', {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    })
    .then(res => setGroups(res.data.data || []))
    .catch(() => {})
    .finally(() => setLoading(false));
  }, []);

 <p className="plr-empty">{locale === 'kz' ? 'Топтар табылмады' : 'Группы не найдены'}</p>

  return (
    <section className="dashboard-body">
      <div className="plr-heading">
        <div className="plr-icon">
          <i className="ti ti-file-description" aria-hidden="true" />
        </div>
        <h2>{locale === 'kz' ? 'Сараптамалық қорытындылар' : 'Экспертные решения'}</h2>
      </div>
      {groups.length === 0 ? (
        <p>{locale === 'kz' ? 'Топтар табылмады' : 'Группы не найдены'}</p>
      ) : (
      <div className="plr-list">
        {groups.map(group => (
        <div key={group.id} className="plr-card">
          <div className="plr-card-left">
            <div className="plr-card-title">{group.title}</div>
            <div className="plr-card-meta">
              <span className="plr-meta-item">
                <i className="ti ti-calendar" aria-hidden="true" />
                {new Date(group.created_at).toLocaleString()}
              </span>
              <span className="plr-meta-item">
                <i className="ti ti-hash" aria-hidden="true" />
                {locale === 'kz' ? 'Шығыс нөмірі' : 'Исходящий номер'}: {group.outgoing_number}
              </span>
            </div>
          </div>
          <button className="plr-btn" onClick={() => setSelectedGroup(group)}>
            <i className="ti ti-eye" aria-hidden="true" />
            {locale === 'kz' ? 'Нәтижені көру' : 'Посмотреть результат'}
          </button>
        </div>
       ))}
      </div>
      )}

      {selectedGroup && (
        <GroupResultModal
          group={selectedGroup}
          onClose={() => setSelectedGroup(null)}
          locale={locale}
        />
      )}
    </section>
  );
}
